<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Aguarde :show="httpSend"></Aguarde>
    <div class="row">
      <div class="col-12 mb-2">
        <router-link
            class="btn btn-label btn-primary mr-3"
            tag="a"
            href="javascript: void(0);"
            to="/contribuinte/ranfs/lista">
          <i class="bx bx-detail label-icon"></i>
          Lista de Ranfs
        </router-link>
        <router-link
            class="btn btn-label btn-dark"
            tag="a"
            href="javascript: void(0);"
            to="/contribuinte/ranfs/gerar">
          <i class="bx bx-plus label-icon"></i>
          Nova Ranfs
        </router-link>
      </div>
      <div class="col-12">
        <embed ref="embedDocumento" id="embedDocumento" :src="link_nota+'#nameddest=destination'"
               style="width:100%; height:100em;"
               type="application/pdf">
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import Aguarde from "@/components/widgets/aguarde";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {urlTemp} from "@/helps/impressao";
import {setRelRanfs} from "@/api/relatorio/ranfs";

export default {
  page: {
    title: "Ranfs",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Aguarde
  },
  data() {
    return {
      title: "Ranfs",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Lista de Ranfs',
          href: '/contribuinte/ranfs/lista',
        },
        {
          text: 'Visualizar',
          active: true,
        },
      ],
      link_nota: '',
      httpSend: false,
    };
  },
  created() {
    this.httpSend = true
    urlTemp(setRelRanfs(this.$route.params.ran_hash)).then(result => {
      this.link_nota = result;
    }).catch(error => {
      console.log(error)
    }).finally(() => {
      this.httpSend = false
    })
  }
};
</script>


